import { render } from "./ResetForm.vue?vue&type=template&id=75b5d615"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"

import "./ResetForm.vue?vue&type=style&index=0&id=75b5d615&lang=scss"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__